export function formatDate(
    date: Date,
    getMonthName: (dateIndex: number, type: 'full' | 'shorthand') => string
) {
    const rawHours = date.getHours()

    const period = rawHours >= 12 ? 'PM' : 'AM'

    const formattedHours = rawHours % 12 || 12

    const hours = formattedHours.toString().padStart(2, '0')

    const minutes = date
        .getMinutes()
        .toString()
        .padStart(2, '0')

    return `${getMonthName(
        date.getMonth(),
        'shorthand'
    )} ${date.getDate()}, ${hours}:${minutes} ${period}`
}